import './tagComponent.scss';
import {SvgIcon} from '../icons/svgIcon';
import {Icons} from '../icons/icons';
import React, {useEffect, useState} from 'react';
import {DeepReadonly} from 'utility-types';
import {HibuTag} from '../search/search-types';
import classNames from 'clsx';
import {HibuTooltip} from '../common/hibuTooltip/hibuTooltip';
import {getOpenstreetmapUrl} from '../utils/utils';

type TagComponentProps = {
    tag: DeepReadonly<HibuTag>;
    tagTitle: string;
    handleTagSelected?: (tag: HibuTag) => void;
    handleTagDeselected?: () => void;
};

export const TagComponent = React.memo((props: TagComponentProps) => {
    const refTag = React.createRef<HTMLSpanElement>();
    const [ellipsisActive, setEllipsisActive] = useState<boolean>(false);
    const [selected, setSelected] = useState<boolean>(false);

    const onSelect = () => {
        const hibuTag = props.tag as HibuTag;
        if (props.handleTagSelected) props.handleTagSelected(hibuTag);
        setSelected(true);
    };
    const onDeselect = () => {
        if (props.handleTagDeselected) props.handleTagDeselected();
        setSelected(false);
    };

    useEffect(() => {
        if (refTag.current) {
            setEllipsisActive(refTag.current.offsetWidth < refTag.current.scrollWidth);
        }
    }, [refTag]);

    let tag;
    if (ellipsisActive) {
        tag = (
            <HibuTooltip tooltipKey={props.tag.label} placement={'top'}>
                <span
                    ref={refTag}
                    className={classNames(
                        'tag-value-text',
                        props.tagTitle !== 'doctype' && 'highlight-' + props.tagTitle
                    )}
                >
                    {props.tag.id.startsWith('ruta') ? props.tag.id.split(':')[1] + ':\n' : ''}
                    {props.tag.label + ' '}
                </span>
            </HibuTooltip>
        );
    } else {
        tag = (
            <span
                ref={refTag}
                className={classNames('tag-value-text', props.tagTitle !== 'doctype' && 'highlight-' + props.tagTitle)}
            >
                {props.tag.id.startsWith('ruta') ? props.tag.id.split(':')[1] + ':\n' : ''}
                {props.tag.label + ' '}
            </span>
        );
    }

    const showWikidata = () => {
        if (selected && props.tag.id.startsWith('wikidata')) {
            const wikidataId = props.tag.id.substr(props.tag.id.lastIndexOf(':') + 1);
            const wikidataUrl = 'https://www.wikidata.org/wiki/' + wikidataId;
            return (
                <a href={wikidataUrl} target="_blank" rel="noopener noreferrer" className="tag-link-icon">
                    <SvgIcon icon={Icons.WEB} />
                </a>
            );
        }
    };

    const validCoordinatesExist = () => {
        return props.tag.extra &&
            props.tag.extra.coordinates &&
            props.tag.extra.coordinates[0] !== '0' &&
            props.tag.extra.coordinates[1] !== '0';
    }

    const showLocation = () => {
        if (selected && props.tagTitle === 'location' && props.tag.extra && validCoordinatesExist()) {
            const url = getOpenstreetmapUrl(props.tag.extra);
            return (
                <a href={url} target="_blank" rel="noopener noreferrer" className="tag-link-icon">
                    <SvgIcon icon={Icons.MAP} />
                </a>
            );
        }
    };

    return (
        <div
            className={classNames('tag-component', selected ? 'selected' : '')}
            onMouseEnter={onSelect}
            onMouseLeave={onDeselect}
        >
            <div className={classNames('tag-value')} key={props.tag.id}>
                {tag}
                {showWikidata()}
                {showLocation()}
            </div>
        </div>
    );
});
